import {useMutation, useQueryClient} from '@tanstack/react-query';
import {
  API,
  CreateGuestByParticipantPayload,
  CreateGuestByParticipantResponse,
  FieldsErrorResponse,
} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {useReservation} from 'context/reservation';

function useCreateGuestByParticipant() {
  const queryClient = useQueryClient();
  const {reservationId} = useReservation();

  return useMutation<
    CreateGuestByParticipantResponse,
    FieldsErrorResponse,
    {
      id?: string;
      payload: Omit<CreateGuestByParticipantPayload, 'reservation_id'>;
    }
  >({
    mutationFn: ({payload}) =>
      API.guest.createGuestByParticipant({
        reservation_id: reservationId || '',
        ...payload,
      }),
    onSuccess: async () => {
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.reservation],
      });
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.summary],
      });
      void queryClient.resetQueries({
        queryKey: [QUERY_CACHE_KEYS.formFields],
      });
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.guestGroup],
      });
    },
  });
}

export {useCreateGuestByParticipant};
